export default {
    "name": "GetMe",
    "kind": "HoudiniQuery",
    "hash": "536950f398e0306281bf9b58f34244980aa5f876bf4a078f9f89b2aeb858bbd8",

    "raw": `query GetMe {
  me {
    car {
      fullname
      motor
      energy
      constructionYears
    }
    carId
    tripPreferences {
      tripConstraint
      distanceSystem
      currency
    }
    itinerariesFavorites {
      coordinates {
        lat
        lng
      }
      mode
      currency
      distanceSystem
      departureName
      arrivalName
      steps
      isEv
      withCaravan
      constraints
      duration
      distance {
        value
        unit
      }
      totalCost {
        amount
        currency
      }
      timestamp
      carId
    }
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "me": {
                "type": "User",
                "keyRaw": "me",

                "selection": {
                    "fields": {
                        "car": {
                            "type": "UserCar",
                            "keyRaw": "car",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "fullname": {
                                        "type": "String",
                                        "keyRaw": "fullname",
                                        "visible": true
                                    },

                                    "motor": {
                                        "type": "String",
                                        "keyRaw": "motor",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "energy": {
                                        "type": "CarEnergy",
                                        "keyRaw": "energy",
                                        "visible": true
                                    },

                                    "constructionYears": {
                                        "type": "String",
                                        "keyRaw": "constructionYears",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "carId": {
                            "type": "String",
                            "keyRaw": "carId",
                            "nullable": true,
                            "visible": true
                        },

                        "tripPreferences": {
                            "type": "UserTripPreferences",
                            "keyRaw": "tripPreferences",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "tripConstraint": {
                                        "type": "ItineraryConstraint",
                                        "keyRaw": "tripConstraint",
                                        "visible": true
                                    },

                                    "distanceSystem": {
                                        "type": "DistanceSystem",
                                        "keyRaw": "distanceSystem",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "itinerariesFavorites": {
                            "type": "ItineraryFavorite",
                            "keyRaw": "itinerariesFavorites",

                            "selection": {
                                "fields": {
                                    "coordinates": {
                                        "type": "Coordinates",
                                        "keyRaw": "coordinates",

                                        "selection": {
                                            "fields": {
                                                "lat": {
                                                    "type": "Float",
                                                    "keyRaw": "lat",
                                                    "visible": true
                                                },

                                                "lng": {
                                                    "type": "Float",
                                                    "keyRaw": "lng",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "mode": {
                                        "type": "ItineraryTravelMode",
                                        "keyRaw": "mode",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    },

                                    "distanceSystem": {
                                        "type": "DistanceSystem",
                                        "keyRaw": "distanceSystem",
                                        "visible": true
                                    },

                                    "departureName": {
                                        "type": "String",
                                        "keyRaw": "departureName",
                                        "visible": true
                                    },

                                    "arrivalName": {
                                        "type": "String",
                                        "keyRaw": "arrivalName",
                                        "visible": true
                                    },

                                    "steps": {
                                        "type": "String",
                                        "keyRaw": "steps",
                                        "visible": true
                                    },

                                    "isEv": {
                                        "type": "Boolean",
                                        "keyRaw": "isEv",
                                        "visible": true
                                    },

                                    "withCaravan": {
                                        "type": "Boolean",
                                        "keyRaw": "withCaravan",
                                        "visible": true
                                    },

                                    "constraints": {
                                        "type": "ItineraryConstraint",
                                        "keyRaw": "constraints",
                                        "visible": true
                                    },

                                    "duration": {
                                        "type": "Int",
                                        "keyRaw": "duration",
                                        "visible": true
                                    },

                                    "distance": {
                                        "type": "Distance",
                                        "keyRaw": "distance",

                                        "selection": {
                                            "fields": {
                                                "value": {
                                                    "type": "Float",
                                                    "keyRaw": "value",
                                                    "visible": true
                                                },

                                                "unit": {
                                                    "type": "DistanceUnit",
                                                    "keyRaw": "unit",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "totalCost": {
                                        "type": "Price",
                                        "keyRaw": "totalCost",

                                        "selection": {
                                            "fields": {
                                                "amount": {
                                                    "type": "Float",
                                                    "keyRaw": "amount",
                                                    "visible": true
                                                },

                                                "currency": {
                                                    "type": "String",
                                                    "keyRaw": "currency",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "timestamp": {
                                        "type": "Float",
                                        "keyRaw": "timestamp",
                                        "visible": true
                                    },

                                    "carId": {
                                        "type": "String",
                                        "keyRaw": "carId",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=f52ec0709c9448b7b08bac4c691e3c499c326342268f85a6b9879aa7a42012da";